import axios from 'axios'
import { useRoute } from 'vue-router'

import { useAppStore } from '@/stores/AppStore'

const HOUR = 60 * 60 * 1_000
const versionURL = `${import.meta.env.VITE_VUE_APP_ORIGINAL_URL}version.json`
const versionCheckTimeout = HOUR

export const appCheck = () => {
  const route = useRoute()

  const { getAppVersion } = useAppStore()

  let appRefreshInterval = setInterval(() => reloadApp(), versionCheckTimeout)
  const reloadApp = async () => {
    let appVersion;
    try {
      appVersion = await actualAppVersion()
    } catch (e) {
      console.error(e);
      return;
    }
    const preventAppRefresh = route.matched.some((record) => record.meta.preventAppRefresh)
    if (getAppVersion && getAppVersion !== appVersion && !preventAppRefresh) {
      window.location.reload()
    }
    clearInterval(appRefreshInterval)
    appRefreshInterval = setInterval(() => reloadApp(), versionCheckTimeout)
  }

  setTimeout(() => window.location.reload(), 24 * HOUR)
}

export const actualAppVersion = async () => {
  const { data } = await axios.get(versionURL)
  return data.actual_version
}
